module.exports = __webpack_public_path__ + "static/media/XY.a27ea35a.png";